import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useLocalizedMeta } from "@/hooks/useLocalizedMeta";

export default function NotFound() {
  const { t } = useTranslation();
  useLocalizedMeta();

  return (
    <>
      <Navbar />
      <main className="flex min-h-[60vh] flex-col items-center justify-center bg-background-50 px-4 py-20 text-center md:px-6">
        <span className="font-heading text-7xl font-extrabold leading-none text-primary-200 md:text-8xl">
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("notFound.title")}
        </h1>
        <p className="mt-3 max-w-md text-base leading-relaxed text-foreground-600">
          {t("notFound.subtitle")}
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer transition-colors"
        >
          <i className="ri-home-4-line"></i>
          {t("notFound.backHome")}
        </Link>
      </main>
      <Footer />
    </>
  );
}